import 'moment/locale/ja'
import locale from 'antd/lib/locale/ja_JP'
import { navigate } from 'gatsby'
import { ConfigProvider as AntdConfigProvider } from 'antd'
import { PersistGate } from 'redux-persist/integration/react'
import { ApolloProvider } from '@apollo/client'
import {
  AuthenticationRequired,
  AppVersion,
  PermissionCheck,
  SessionCheck,
  Header,
} from './src/components/common'
import { SignedIn } from './src/components/templates'
import CalendarPageLayout from './src/components/templates/calendar-menu/calendarPageLayout'
import { validateMessages } from './src/utils/messages'
import { Auth0Provider } from './src/lib/auth'
import { ReduxProvider, store } from './src/lib/redux'
import { persistor } from './src/lib/redux/store'
import client from './src/lib/graphql/client'
import config from './src/config'
import './src/styles/global.css'

const onRedirectCallback = (appState) => {
  // Use Gatsby's navigate method to replace the url
  navigate(appState?.returnTo || '/', { replace: true })
}

/**
 * wrap every page in a component
 * @see https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser#wrapPageElement
 * @param element
 * @param props
 * @return {JSX.Element}
 */
export const wrapPageElement = ({ element, props }) => {
  if (props.path.match(/^\/admin/)) {
    return (
      <>
        <AppVersion />

        <AuthenticationRequired>
          <SessionCheck>
            <PermissionCheck>
              <SignedIn {...props}>{element}</SignedIn>
            </PermissionCheck>
          </SessionCheck>
        </AuthenticationRequired>
      </>
    )
  } else if (props.path.match(/^\/calendar/)) {
    return (
      <>
        <AppVersion />

        <AuthenticationRequired>
          <SessionCheck>
            <PermissionCheck>
              <CalendarPageLayout {...props}>{element}</CalendarPageLayout>
            </PermissionCheck>
          </SessionCheck>
        </AuthenticationRequired>
      </>
    )
  } else {
    return (
      <>
        <AppVersion />

        {element}
      </>
    )
  }
}

/**
 * @see https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser#wrapRootElement
 * @param element
 * @return {JSX.Element}
 */
export const wrapRootElement = ({ element }) => (
  <>
    <ApolloProvider client={client}>
      <Auth0Provider
        domain={config.auth0.domain}
        clientId={config.auth0.clientId}
        redirectUri={config.auth0.callback}
        audience={config.auth0.audience}
        responseType="token id_token"
        scope="openid profile email"
        cacheLocation="localstorage"
        useCookiesForTransactions={true}
        useFormData={true}
        onRedirectCallback={onRedirectCallback}
      >
        <ReduxProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AntdConfigProvider locale={locale} form={{ validateMessages }}>
              {element}
            </AntdConfigProvider>
          </PersistGate>
        </ReduxProvider>
      </Auth0Provider>
    </ApolloProvider>
  </>
)
